export const DefaultData = {
  user: {
    additionalInfo: '',
    cardBalance: '',
    cardBalanceUpdatedOn: '',
    cardNumber: '',
    cardNumberConfirmedOn: '',
    email: '',
    firstName: '',
    id: '',
    image: '',
    lastName: '',
    phoneNumber: '',
    roles: [],
    service: '',
    userName: '',
    mop: '',
    marketingContactAcceptedOn: null,
  }
};

export const DataReducer = (data, { type, payload }) => {
  switch (type) {
    case 'SET_USER':
      return {
        ...data,
        user: {
          ...payload,
        }
      };
  default:
    return data;
  }
};
